import { jsx as a, Fragment as s } from "react/jsx-runtime";
import { Children as i, isValidElement as y } from "react";
const l = ({ children: r, invalidChildren: n = [] }) => {
  const o = new Set(n.map((e) => e.toLowerCase())), p = i.toArray(r).filter((e) => {
    let t;
    return y(e) ? (typeof e.type == "string" ? t = e.type : typeof e.type == "object" && typeof e.type.displayName == "string" ? t = e.type.displayName : typeof e.type == "function" && (t = e.type.displayName ?? e.type.name), !(t && o.has(t.toLowerCase()))) : !0;
  });
  return /* @__PURE__ */ a(s, { children: p });
};
export {
  l as ChildFilter
};
